export const contractStatus = value => ({ DRAFT: '초안', CONFIRMED: '확정', CANCELLED: '취소', REVOKED: '철회' }[value] || '확인 필요')
export const contractPeriod = value => ({ UPCOMING: '시작 예정', ACTIVE: '기간 내', EXPIRED: '기간 만료' }[value] || '확인 필요')

/** 계약 API에서 인증해 받은 바이트만 로컬 다운로드한다. 서버의 임의 URL을 열지 않는다. */
export function saveContractBlob(blob, name) {
  const url = URL.createObjectURL(blob), link = document.createElement('a')
  link.href = url; link.download = name; document.body.append(link); link.click(); link.remove()
  setTimeout(() => URL.revokeObjectURL(url), 1000)
}
